import React, { useEffect, useState, useContext, useRef } from "react";
import axios from "axios";
import NoIndex from "../NoIndex";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import { Modal, Button } from "react-bootstrap";
import TopImage from "../../images/Dashboard_IMG.webp";
import { Doughnut } from "react-chartjs-2";
import { UserCircle, X, LogOut, ChevronDown, Check } from "lucide-react";
import OrderStatsModal from "./OrderStatsModal";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend as ChartLegend,
} from "chart.js";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import MyContext from "../../MyContext";

ChartJS.register(ArcElement, ChartTooltip, ChartLegend);

const data = [
  { name: "Jan", uv: 1000 },
  { name: "Feb", uv: 3000 },
  { name: "Mar", uv: 2000 },
  { name: "Apr", uv: 2780 },
  { name: "May", uv: 1890 },
  { name: "Jun", uv: 2390 },
  { name: "Feb", uv: 3000 },
  { name: "Mar", uv: 2000 },
  { name: "Apr", uv: 2780 },
  { name: "May", uv: 1890 },
  { name: "Jun", uv: 2390 },
  { name: "Jul", uv: 1000 },
];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "#fff",
          border: "1px solid #ccc",
          padding: "10px",
        }}
      >
        <p>{`${label} : ${payload[0].value}`}</p>
      </div>
    );
  }
  return null;
};

const Dashboard = ({ userID, handleLogout }) => {
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);

  const [dashboardData, setDashboardData] = useState({});
  const [percentage, setPercentage] = useState("");
  const [qrCode, setQrCode] = useState("");
  const [subscriptionDetails, setSubscriptionDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [orderAnalytics, setorderAnalytics] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [interval, setInterval] = useState("30");
  const [isProductStatsVisible, setIsProductStatsVisible] = useState(false);

  const [totalQuote, setTotalQuote] = useState(0);
  const [sentOnNetwork, setSentOnNetwork] = useState(0);
  const [semiDonutData, setSemiDonutData] = useState({
    datasets: [
      {
        data: [0, 0],
        backgroundColor: ["rgba(1, 195, 125, 1)", "rgba(200, 200, 200, 0.2)"],
        borderColor: ["rgba(1, 195, 125, 1)", "rgba(200, 200, 200, 0.2)"],
        borderWidth: 1,
        cutout: "80%",
        rotation: -90,
        circumference: 180,
      },
    ],
  });

  function onCloseModal() {
    setIsProductStatsVisible(false);
  }

  const fetchActivePlanData = async () => {
    try {
      const requestbody = {
        userid: userID,
        interval: interval,
      };

      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/getDashboardAnalytics`,
        requestbody,
        config
      );

      if (response.data.responseCode === "00") {
        const { totalQuote, sentOnNetwork } = response.data.data;
        const remainingMessages = totalQuote - sentOnNetwork;

        setSemiDonutData({
          labels: ["Sent Messages", "Available Messages"],
          datasets: [
            {
              data: [sentOnNetwork, remainingMessages],
              backgroundColor: ["#FF6384", "rgba(1, 195, 125, 1)"],
              hoverBackgroundColor: ["#FF6384", "rgba(1, 195, 125, 1)"],
            },
          ],
        });

        setTotalQuote(totalQuote);
        setSentOnNetwork(sentOnNetwork);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching active plan data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActivePlanData();
  }, []);

  const semiDonutOptions = {
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    rotation: -90,
    circumference: 180,
    maintainAspectRatio: false,
  };

  const QrCodeApi = async () => {
    try {
      const requestBody = {
        userid: userID,
        secret: "string",
        message: "Hii",
      };
      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/getQRCode`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        setQrCode(response.data.response.qr_image_url);
      }
    } catch {}
  };

  const downloadQRCode = (qrCodeUrl) => {
    const link = document.createElement("a");
    link.href = qrCodeUrl;
    link.download = "QRCode.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const dashboardAPI = async () => {
    try {
      const requestbody = {
        userid: userID,
        interval: interval,
      };

      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/getDashboardAnalytics`,
        requestbody,
        config
      );

      if (response.data.responseCode === "00") {
        const {
          sentOnNetwork,
          interested,
          notInterested,
          totalSent,
          totalDelivered,
          totalRead,
          totalReplied,
          totalFailed,
          totalAmoutSpent,
          totalQuote,
        } = response.data.data;

        const remainingMessages = totalQuote - sentOnNetwork;

        setDashboardData({
          sentOnNetwork,
          interested,
          notInterested,
          totalSent,
          totalDelivered,
          totalRead,
          totalReplied,
          totalFailed,
          totalAmoutSpent,
          totalQuote,
          remainingMessages,
        });

        setSemiDonutData({
          labels: ["Sent Messages", "Available Messages"],
          datasets: [
            {
              data: [sentOnNetwork, remainingMessages],
              backgroundColor: ["#FF6384", "rgba(1, 195, 125, 1)"],
              hoverBackgroundColor: ["#FF6384", "rgba(1, 195, 125, 1)"],
            },
          ],
        });
      } else {
        console.error("Error: Response code is not 00");
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  const orderAPI = async () => {
    try {
      const requestbody = {
        userid: userID,
        interval: interval,
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/getOrderAnalyticsData`,
        requestbody,
        config
      );
      if (response.data.responseCode === "00") {
        setorderAnalytics(response.data.response);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dashboardAPI();
    QrCodeApi();
    orderAPI();
  }, [interval]);

  useEffect(() => {
    if (
      !loading &&
      dashboardData.sent_to_network !== undefined &&
      dashboardData.not_sent_to_network !== undefined
    ) {
      const donut = document.getElementById("donut-chart");
      const total =
        parseInt(dashboardData.sent_to_network) +
        parseInt(dashboardData.not_sent_to_network);
      setPercentage(total);
      const donutFill = (dashboardData.sent_to_network / total) * 440;
      if (donut) donut.style.strokeDasharray = `${donutFill} 440`;
    }
  }, [dashboardData, loading]);

  const [userAccounts, setUserAccounts] = useState([]);
  const [selectedUserAccount, setSelectedUserAccount] = useState("");
  const [userMobile, setUserMobile] = useState("");
  const [TopOrders, setTopOrders] = useState([]);
  const [TopOrdersAnalytics, setTopOrdersAnalytics] = useState([]);
  const [Platform, setPlatform] = useState("pos");

  const getUserAccountsApi = async (mobile) => {
    try {
      const requestbody = { mobile };
      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/getUserAccounts`,
        requestbody,
        config
      );
      if (response.data.responseCode === "00") {
        setUserAccounts(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching active plan data:", error);
    }
  };

  const getTopOrderApi = async () => {
    try {
      setLoading(true);
      const requestbody = {
        userid: userID,
        interval: interval,
        platform: Platform,
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getBestSellingProducts`,
        requestbody,
        config
      );
      if (response.data.responseCode === "00") {
        setTopOrders(response.data.response.slice(0, 4));
        setTopOrdersAnalytics(response.data.response);
      } else {
        setTopOrders([]);
        setTopOrdersAnalytics([]);
      }
    } catch (error) {
      console.error("Error fetching active plan data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTopOrderApi();
  }, [Platform, interval]);

  const switchUserAccountsApi = async (selectedId) => {
    try {
      const requestbody = {
        mobile: userMobile,
        accountId: selectedId,
      };
      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/switchUserAccount`,
        requestbody,
        config
      );
      if (response.data.responseCode === "00") {
        sessionStorage.setItem("user", JSON.stringify(response.data.response));
        getUserAccountsApi(userMobile);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error fetching active plan data:", error);
    }
  };

  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      if (parsedUser.mobile) setUserMobile(parsedUser.mobile);
    }
  }, []);

  useEffect(() => {
    if (userMobile) getUserAccountsApi(userMobile);
  }, [userMobile]);

  const [showProfileCard, setShowProfileCard] = useState(false);
  const profileCardRef = useRef();
  const [selectedMerchant, setSelectedMerchant] = useState(null);

  useEffect(() => {
    if (Array.isArray(userAccounts) && userAccounts.length > 0) {
      const activeAcc =
        userAccounts.find((acc) => acc.status === "active") || userAccounts[0];
      setSelectedMerchant(activeAcc);
    }
  }, [userAccounts]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileCardRef.current && !profileCardRef.current.contains(e.target)) {
        setShowProfileCard(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMerchantSwitch = (account) => {
    setSelectedMerchant(account);
    switchUserAccountsApi(account.id);
    setShowProfileCard(false);
  };

  const otherAccounts =
    userAccounts?.filter((acc) => acc.id !== selectedMerchant?.id) || [];

  const ShimmerCard = () => (
    <div className="col-12 col-sm-6">
      <Card className="h-100 w-100 border shadow-none shimmer-card">
        <Card.Body className="p-2 d-flex flex-column">
          <div className="d-flex align-items-center gap-2 mb-2">
            <div className="shimmer rounded-circle" style={{ width: 24, height: 24 }}></div>
            <div className="shimmer flex-grow-1" style={{ height: 14, borderRadius: 4 }}></div>
          </div>
          <hr className="my-2" />
          <div className="d-flex justify-content-between mb-1">
            <div className="shimmer" style={{ width: "40%", height: 10, borderRadius: 4 }}></div>
            <div className="shimmer" style={{ width: "20%", height: 10, borderRadius: 4 }}></div>
          </div>
          <div className="d-flex justify-content-between mb-1">
            <div className="shimmer" style={{ width: "40%", height: 10, borderRadius: 4 }}></div>
            <div className="shimmer" style={{ width: "20%", height: 10, borderRadius: 4 }}></div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );

  return (
    <>
      <NoIndex />
      <div className="" style={{  fontFamily: "Nunito,sans-serif" }}>
        {/* Top Banner: same desktop layout, collapses on small screens */}
        <div className="row g-3 m-0">
          <div className="col-12">
            <div className="d-flex flex-wrap mx-2 p-0 anlk-animated-gradient justify-content-between border-15-black">
              <div className="anlk-particle-wrapper">
                <div className="anlk-bubble anlk-bubble1"></div>
                <div className="anlk-bubble anlk-bubble2"></div>
              </div>

              <div className="col-12 col-md-7 col-xl-6 p-4">
                <div className="text-top">
                  Integrated Your System with Anlook and Maximize All Benefits
                </div>
                <div className="pt-2">
                  <Link to="/Profile/Plans">
                    <button type="button" className="blue-button">Upgrade Plan</button>
                  </Link>
                </div>
              </div>

              <div className="col-6 col-md-4 p-0 m-0 order-3 order-md-2">
                <div className="d-flex p-0 m-0 justify-content-end align-items-center"
                     style={{ overflow: "hidden", height: "180px" }}>
                  <img
                    src={TopImage}
                    height={300}
                    alt=""
                    className="img-fluid"
                    style={{ objectFit: "cover", position: "relative", top: "+80px" }}
                  />
                </div>
              </div>

              <div className="col-6 col-md-1 col-xl-2 text-end order-2 order-md-3">
                <div className="anlk-profile-container me-2 mt-2">
                  <div
                    className="anlk-profile-trigger-badge mt-2"
                    onClick={() => setShowProfileCard(!showProfileCard)}
                  >
                    <UserCircle className="anlk-avatar-icon" size={20} />
                    <span className="anlk-profile-name-badge">
                      {selectedMerchant?.account_name || "Account"}
                    </span>
                    <ChevronDown
                      size={16}
                      className={`anlk-badge-chevron ${showProfileCard ? "rotate" : ""}`}
                    />
                  </div>

                  {showProfileCard && selectedMerchant && (
                    <div className="anlk-profile-card" ref={profileCardRef}>
                      <div className="anlk-profile-header">
                        <div className="anlk-profile-email">
                          {selectedMerchant?.email || selectedMerchant?.account_name}
                        </div>
                        <X size={18} className="anlk-close-icon" onClick={() => setShowProfileCard(false)} />
                      </div>

                      <div className="anlk-profile-body">
                        <UserCircle size={60} className="anlk-avatar-lg" />
                        <div className="anlk-greeting">
                          Hi, {selectedMerchant?.account_name?.split(" ")[0] || "User"}!
                        </div>
                        <div className="anlk-manage-btn">Switch Account</div>
                      </div>

                      {otherAccounts.length > 0 && (
                        <ul className="anlk-switch-list">
                          {otherAccounts.map((acc) => (
                            <li key={acc.id} onClick={() => handleMerchantSwitch(acc)}>
                              <UserCircle size={18} />
                              <span>{acc.account_name}</span>
                              {acc.status === "active" && <Check size={14} className="anlk-check-icon" />}
                            </li>
                          ))}
                        </ul>
                      )}

                      <div className="anlk-profile-actions" onClick={handleLogout}>
                        <button className="anlk-action-btn">
                          <LogOut size={16} /> Log out
                        </button>
                      </div>

                      <div className="anlk-terms-links">
                        <a href="#">Privacy Policy</a>
                        <span>·</span>
                        <a href="#">Terms of Service</a>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Main Grid: Left column (xl-4) + Right column (xl-8) */}
          <div className="col-12 col-xl-4">
            {/* QR */}
            <div className="p-3 m-2 my-3 bg-white d-flex flex-column justify-content-between border-15-black dashboard-height-2">
              <div className="row g-3 align-items-center">
                <div className="col-5 col-sm-4 d-flex justify-content-center">
                  <img src={qrCode} alt="" className="img-fluid" style={{ maxHeight: 120, objectFit: "contain" }} />
                </div>
                <div className="col-7 col-sm-8">
                  <p className="text-3-2 text-center text-sm-start mb-2">Scan to start chat</p>
                  <div className="d-grid gap-2">
                    <button className="blue-button" onClick={() => downloadQRCode(qrCode)}>Download</button>
                    <button className="gray-button">Share</button>
                  </div>
                </div>
              </div>
            </div>

            {/* Active Plan */}
            <div className="p-3 m-2 my-3 bg-white d-flex flex-column justify-content-between border-15-black dashboard-height-2">
              <div className="row g-3 align-items-stretch">
                <div className="col-12 col-md-6 d-flex flex-column align-items-center">
                  <p className="text-3-2 mb-0">Active Plan</p>
                  <div className="position-relative w-100" style={{ height: "8rem" }}>
                    <Doughnut data={semiDonutData} options={semiDonutOptions} />
                    <div
                      className="position-absolute text-center"
                      style={{ top: "50%", left: "50%", transform: "translate(-50%,-25%)" }}
                    >
                      <div style={{ fontWeight: "bold" }}>{totalQuote - sentOnNetwork}</div>
                      <div style={{ fontSize: "12px", whiteSpace: "nowrap" }}>Available Messages</div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <div className="light-blue border-15-only p-2 h-100 d-flex flex-column justify-content-center">
                    <div className="text-5">Messages Left : <b>{totalQuote - sentOnNetwork}</b></div>
                    <div className="pt-2">
                      <Link to="/Profile/Plans">
                        <button type="button" className="blue-button w-100">Upgrade Plan</button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Top Selling Orders */}
            <div className="m-2 my-3">
              <Card className="top-selling-orders-card w-100 rounded-3 border-15-black shadow-none">
                <Card.Body className="p-3">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0 fw-semibold">Top Selling Orders</h6>
                    <select
                      className="form-select form-select-sm w-auto"
                      value={Platform}
                      onChange={(e) => setPlatform(e.target.value)}
                    >
                      <option value="pos">POS</option>
                      <option value="whatsapp">WhatsApp</option>
                    </select>
                  </div>

                  <div className="row g-3">
                    {loading
                      ? Array(4).fill(0).map((_, i) => <ShimmerCard key={i} />)
                      : TopOrders.length !== 0
                        ? TopOrders.map((item) => (
                            <div key={item.id} className="col-12 col-sm-6">
                              <Card className="h-100 w-100 border shadow-none" style={{ borderRadius: "0.5rem" }}>
                                <Card.Body className="p-2 d-flex flex-column">
                                  <div className="mb-2">
                                    <div className="d-flex align-items-center gap-2">
                                      <div style={{ width: 24, height: 24, flexShrink: 0, position: "relative" }}>
                                        <img
                                          src={item.productImage}
                                          alt={item.productName}
                                          className="rounded-circle"
                                          style={{ width: "100%", height: "100%", objectFit: "cover", position: "absolute" }}
                                        />
                                      </div>
                                      <div className="flex-grow-1">
                                        <span className="fw-medium text-truncate d-block" style={{ fontSize: "0.875rem", lineHeight: 1.2 }}>
                                          {item.productName}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  <hr className="my-2 w-100" style={{ margin: "0.25rem 0" }} />

                                  <div className="pt-1" style={{ fontSize: "0.75rem" }}>
                                    <div className="d-flex justify-content-between mb-1 text-muted">
                                      <span>Product ID</span>
                                      <span className="fw-medium text-dark ms-2">{item.productId}</span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-1 text-muted">
                                      <span>Order Sold</span>
                                      <span className="fw-medium text-dark ms-2">{item.orderCount}</span>
                                    </div>
                                    <div className="d-flex justify-content-between text-muted">
                                      <span>Order Placed</span>
                                      <span className="fw-medium text-dark ms-2">{item.orderCount}</span>
                                    </div>
                                  </div>
                                </Card.Body>
                              </Card>
                            </div>
                          ))
                        : (
                          <div className="border rounded bg-light p-4 text-center">
                            <div className="fw-semibold text-muted">
                              No Top Orders Found on <span className="text-dark">{Platform.toUpperCase()}</span>
                            </div>
                            <small className="text-secondary">Try changing filters or date range</small>
                          </div>
                        )}
                  </div>

                  <div className="mt-1 cursor-pointer" onClick={() => setIsProductStatsVisible(true)}>
                    <a className="text-primary text-decoration-none" style={{ fontSize: "0.875rem" }}>
                      View Analytics
                    </a>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>

          <div className="col-12 col-xl-8">
            {/* Lead Generated */}
            <div className="p-3 m-2 my-3 bg-white d-flex flex-column justify-content-between border-15-black dashboard-height">
              <div className="d-flex align-items-center justify-content-between">
                <p className="text-3-2 m-0">Lead Generated</p>
                <select
                  className="form-select form-select-sm w-auto"
                  value={interval}
                  onChange={(e) => setInterval(e.target.value)}
                >
                  <option value="1">Today</option>
                  <option value="7">Last 7 Days</option>
                  <option value="30">Last Month</option>
                  <option value="365">Last Year</option>
                </select>
              </div>
              <hr className="m-0" />

              <div className="row g-3 mt-0">
                <div className="col-12 col-lg-8">
                  <div className="bg-gred-voilate h-100 border-15-only px-1">
                    <div className="mt-4">
                      <ResponsiveContainer height={160}>
                        <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                          <defs>
                            <linearGradient id="colorUv4" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="5%" stopColor="rgba(230, 229, 251, 1)" stopOpacity={0.8} />
                              <stop offset="95%" stopColor="rgba(254, 253, 255, 1)" stopOpacity={0} />
                            </linearGradient>
                          </defs>
                          <Tooltip content={<CustomTooltip />} cursor={{ strokeDasharray: "3 3" }} />
                          <Area type="linear" dataKey="uv" stroke="rgba(151, 143, 237, 1)" fill="url(#colorUv4)" />
                        </AreaChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-lg-4 d-flex flex-column gap-2">
                  <div className="p-2 border-15-only bg-light-yellow">
                    <div className="text-3-2 text-start">{dashboardData.sentOnNetwork}</div>
                    <div>
                      <span style={{ display: "inline-block", width: 10, height: 10, backgroundColor: "rgba(250, 152, 0, 1)", marginRight: 5 }}></span>
                      <span className="text-5 text-gray">Sent To Network</span>
                    </div>
                  </div>
                  <div className="p-2 bg-green border-15-only">
                    <div className="text-3-2 text-start">{dashboardData.interested}</div>
                    <div>
                      <span style={{ display: "inline-block", width: 10, height: 10, backgroundColor: "rgba(1, 195, 125, 1)", marginRight: 5 }}></span>
                      <span className="text-5 text-gray">Interested</span>
                    </div>
                  </div>
                  <div className="p-2 border-15-only bg-light-red">
                    <div className="text-3-2 text-start">{dashboardData.notInterested}</div>
                    <div>
                      <span style={{ display: "inline-block", width: 10, height: 10, backgroundColor: "rgba(215, 107, 102, 1)", marginRight: 5 }}></span>
                      <span className="text-5 text-gray">Not Interested</span>
                    </div>
                  </div>
                </div>
              </div>

              <hr className="my-2" />
              <div className="d-flex justify-content-start">
                <div className="text-blue underline cursor-pointer">Lead Details</div>
              </div>
            </div>

            {/* Templates + Order Summary */}
            <div className="row g-3 m-0">
              <div className="col-12 col-lg-6">
                <Card className="templates-status-card w-100 h-100 rounded-3 border shadow-none">
                  <Card.Body className="p-3 d-flex flex-column">
                    <h6 className="text-dark mb-2">Templates Status</h6>
                    <hr className="m-0" />
                    <div className="success-alert rounded-2 p-3 mt-2">
                      <h6 className="mb-1">Hurray!!</h6>
                      <p className="text-muted mb-2" style={{ fontSize: "0.875rem" }}>
                        your latest templates was approved by Meta
                      </p>
                      <div className="d-flex justify-content-between p-2 rounded-2 m-0 align-items-center" style={{ backgroundColor: "#F5F5F5" }}>
                        <span className="text-dark">Temp_0011</span>
                        <span className="text-success p-1 rounded-3" style={{ backgroundColor: "#F2FCF8" }}>Approved</span>
                      </div>
                    </div>

                    <div className="mb-3 mt-2">
                      <p className="text-muted mb-2">Recent Approved Templates</p>
                      <div className="d-flex gap-2">
                        <div className="stat-box bg-success bg-opacity-10 p-2 rounded flex-grow-1">
                          <div className="h5 mb-0 text-dark">100</div>
                          <small className="text-dark">Approved</small>
                        </div>
                        <div className="stat-box bg-warning bg-opacity-10 p-2 rounded flex-grow-1">
                          <div className="h5 mb-0 text-dark">86</div>
                          <small className="textdark">Pending</small>
                        </div>
                        <div className="stat-box bg-danger bg-opacity-10 p-2 rounded flex-grow-1">
                          <div className="h5 mb-0 text-dark">15</div>
                          <small className="text-dark">Rejected</small>
                        </div>
                      </div>
                    </div>

                    <div className="mt-auto">
                      <a href="#" className="text-primary text-decoration-none" style={{ fontSize: "0.875rem" }}>
                        View All Templates
                      </a>
                    </div>
                  </Card.Body>
                </Card>
              </div>

              <div className="col-12 col-lg-6">
                <Card className="order-summary-card w-100 h-100 rounded-3 border shadow-none">
                  <Card.Body className="p-3 d-flex flex-column">
                    <h6 className="text-dark mb-2">Order Summary</h6>
                    <hr className="p-0 m-0" />
                    <div className="mt-2">
                      <p className="text-muted mb-1">Order Amount</p>
                      <div className="d-flex flex-column gap-2">
                        <div className="d-flex justify-content-between align-items-center bg-success bg-opacity-10 p-2 rounded">
                          <span className="text-dark">
                            <span style={{ display: "inline-block", width: 10, height: 10, backgroundColor: "rgba(1, 195, 125, 1)", marginRight: 5 }}></span>
                            Completed
                          </span>
                          <span className="text-dark">{(15520.0).toFixed(2)}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center bg-warning bg-opacity-10 p-2 rounded">
                          <span className="text-dark">
                            <span style={{ display: "inline-block", width: 10, height: 10, backgroundColor: "orange", marginRight: 5 }}></span>
                            Received
                          </span>
                          <span className="text-dark">{(28600.0).toFixed(2)}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center bg-primary bg-opacity-10 p-2 rounded">
                          <span className="text-dark">
                            <span style={{ display: "inline-block", width: 10, height: 10, backgroundColor: "blue", marginRight: 5 }}></span>
                            Dispatched
                          </span>
                          <span className="text-dark">{(23040.0).toFixed(2)}</span>
                        </div>
                      </div>
                    </div>

                    <div className="mt-3">
                      <p className="text-muted mb-2">Order Count</p>
                      <div className="d-flex gap-2">
                        <div className="stat-box bg-success bg-opacity-10 p-2 rounded flex-grow-1 text-center">
                          <div className="h5 mb-0 text-dark">56</div>
                          <small className="text-dark">Completed</small>
                        </div>
                        <div className="stat-box bg-warning bg-opacity-10 p-2 rounded flex-grow-1 text-center">
                          <div className="h5 mb-0 text-dark">120</div>
                          <small className="text-dark">Received</small>
                        </div>
                        <div className="stat-box bg-primary bg-opacity-10 p-2 rounded flex-grow-1 text-center">
                          <div className="h5 mb-0 text-dark">56</div>
                          <small className="text-dark">Dispatched</small>
                        </div>
                      </div>
                    </div>

                    <div className="mt-auto">
                      <a href="#" className="text-primary text-decoration-none" style={{ fontSize: "0.875rem" }}>
                        View Analytics
                      </a>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
        </div>

        {/* Small responsive helpers */}
        <style>{`
          @media (max-width: 991.98px) {
            .dashboard-height,
            .dashboard-height-2 { height: auto !important; }
            .anlk-profile-name-badge { display: none; }
          }
          @media (max-width: 575.98px) {
            .text-top { font-size: 1rem; }
          }
        `}</style>
      </div>

      <circle id="donut-chart" />
      {isProductStatsVisible && (
        <OrderStatsModal data={TopOrdersAnalytics} onClose={() => onCloseModal()} />
      )}
    </>
  );
};

export default Dashboard;
